module.exports = __webpack_public_path__ + "img/42.adc7e714.jpg";